import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-track-dialog',
  templateUrl: './remove-track-dialog.component.html',
  styleUrls: ['./remove-track-dialog.component.scss']
})
export class RemoveTrackDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<RemoveTrackDialogComponent>) {

  }

  loading = false;

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

}
